var _excluded = ["title", "price", "to", "href", "hrefTitle", "labelText", "labelVariant", "hasSiblingWithLabel", "openInNewTab", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
import LabelAtm from "../../atoms/LabelAtm";
import PushOrg from "../../organisms/PushOrg";
import RichTextMol from "../RichTextMol";
import { Arrow, labelMarginBottomSpace, ProductLinkMolContainer, TitleLink } from "./ProductLinkMol.styled";
export var defaultProps = {
  labelVariant: "notify"
};
function ProductLinkMol(_ref) {
  var title = _ref.title,
    price = _ref.price,
    to = _ref.to,
    href = _ref.href,
    hrefTitle = _ref.hrefTitle,
    labelText = _ref.labelText,
    _ref$labelVariant = _ref.labelVariant,
    labelVariant = _ref$labelVariant === void 0 ? defaultProps.labelVariant : _ref$labelVariant,
    hasSiblingWithLabel = _ref.hasSiblingWithLabel,
    openInNewTab = _ref.openInNewTab,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var isSmallOnly = useBreakpoint("small", "medium");
  return /*#__PURE__*/React.createElement(ProductLinkMolContainer, _extends({
    $hasSiblingWithLabel: !!hasSiblingWithLabel,
    $onColor: onColor
  }, restProps), /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: isSmallOnly ? 0 : 1
  }, labelText ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: labelMarginBottomSpace
  }, /*#__PURE__*/React.createElement(LabelAtm, {
    variant: labelVariant,
    size: "small"
  }, labelText)) : null, /*#__PURE__*/React.createElement(TitleLink, {
    to: to,
    href: href,
    title: hrefTitle,
    openInNewTab: openInNewTab,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(RichTextMol, {
    data: title,
    typography: "big4"
  })), price), /*#__PURE__*/React.createElement(Arrow, {
    $onColor: onColor
  }));
}
export default ProductLinkMol;